import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Map from './Map';

import { MAP_TYPES } from '../../constants';
import * as actions from '../../store/actions';
import './MapWrapper.css';

export function MapWrapperComponent(props) {
  return (
    <div className="map-wrapper">
      {props.children}
      {
        props.ignoreMap !== true &&
        <Map
          {...props}
        />
      }
    </div>
  );
}

MapWrapperComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  ignoreMap: PropTypes.bool,
};

export function mapStateToProps(state, ownProps) {
  const zoom = parseInt(state.viewer.defaultZoom, 10);
  return {
    organization: state.organizationId,
    mapTypes: MAP_TYPES,
    mapType: MAP_TYPES[(state.viewer.mapType || MAP_TYPES.ROADMAP).toLocaleUpperCase()],
    profile: state.viewer.layers ? state.viewer.layers.profile : {},
    allLayers: state.viewer.layers ? state.viewer.layers : {},
    businesses: ((state[ownProps.type] || {}).businesses || {}).items,
    defaultZoom: zoom,
    markers: state.viewer.markers,
    mapLoading: state.mapLoading,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    setViewerPolygon: polygon => { dispatch(actions.setViewerPolygon(polygon)); },
    onViewportChanged: viewport => { dispatch(actions.captureViewportInfo(viewport)); },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapWrapperComponent);



// WEBPACK FOOTER //
// ./src/components/Map/MapWrapper.js